


/* Portfolio UUIDs for form builder */
export const FORM_BUILDER_PORTFOLIO_IDS = [
    '8d29e13e-cb60-4364-a37a-3aa43b7f3c43',
    '2c526be1-86fb-486b-aff9-76a65c53ef7d',
    '42d31e88-c7a8-462c-ae50-09a2e2599015',
    '93c6b886-cea8-4c81-b7a7-6d91ae2cc763',
    'be9db8ce-41a4-4e71-833c-c14f0e0323bd',
    '51d67586-b435-4060-b0a7-2f382e3f6fda',
    '68d24aaa-00e4-487c-bbdc-c288636bbfdb',
    '7e35f135-3777-4c82-8c4f-9677a88930c1'
];